//@flow
import * as React from 'react';
import { themr } from 'react-css-themr';
import classnames from 'classnames';
import { dialogFactory } from 'common/components/core/dialog';

import theme from './EntityModal.scss';

type Props = {
    className?: string,
    theme: Object,
    title: string,
    active: boolean,
    onAccept: () => void,
    onDismiss: (?boolean) => void,
    onCancel?: () => void
};

const entityModalFactory = ({ InnerContent }) => {
    const Dialog = dialogFactory({
        InnerContent
    });
    class EntityModal extends React.Component<Props> {
        static defaultProps = {
            active: true
        };
        render() {
            const {
                className,
                theme,
                onCancel,
                onAccept,
                title,
                onDismiss,
                active,
                ...others
            } = this.props;
            return (
                <Dialog
                    {...others}
                    active={active}
                    theme={theme}
                    title={title}
                    className={classnames(className, theme.entityModalOverlay)}
                    onAccept={onAccept}
                    onCancel={onCancel}
                    onDismiss={onDismiss}
                />
            );
        }
    }
    return themr('EntityModal', theme)(EntityModal);
};

const EntityModal = entityModalFactory({});
export { EntityModal, entityModalFactory };
export default EntityModal;
